import React from "react";
import { Link } from "react-router-dom";
import EntityPage from "@/components/EntityPage";
import { useRefData } from "@/context/RefDataContext";

export default function ProjectsPage() {
  const ref = useRefData();

  const columns = [
    {
      key: "code",
      label: "CDARK ID",
      render: (p) => (
        <Link
          to={`/projects/${p.id}`}
          className="font-mono text-xs text-sky-400 hover:underline"
          data-testid={`projects-code-${p.id}`}
        >
          {p.code}
        </Link>
      ),
    },
    {
      key: "client_name",
      label: "Client Name",
      render: (p) => (
        <Link
          to={`/projects/${p.id}`}
          className="text-white hover:text-sky-300 transition-colors"
          data-testid={`projects-name-${p.id}`}
        >
          {p.client_name || p.name}
        </Link>
      ),
    },
    { key: "state", label: "State" },
    { key: "pin_code", label: "Pin Code", render: (p) => <span className="font-mono text-xs text-zinc-400">{p.pin_code || "—"}</span> },
    { key: "commissioned_on", label: "Commissioned On", render: (p) => <span className="text-zinc-400 text-xs">{p.commissioned_on || "—"}</span> },
    {
      key: "google_map_link",
      label: "Map",
      render: (p) =>
        p.google_map_link ? (
          <a
            href={p.google_map_link}
            target="_blank"
            rel="noreferrer"
            className="text-sky-400 hover:underline text-xs"
            data-testid={`projects-map-${p.id}`}
          >
            Open
          </a>
        ) : (
          <span className="text-zinc-600">—</span>
        ),
    },
    { key: "contact_persons", label: "Contacts", render: (p) => <span className="text-zinc-400 text-xs">{(p.contact_persons || []).length}</span> },
  ];

  const fields = [
    { key: "client_name", label: "Client Name (unique)", required: true, full: true },
    { key: "client_relationship_number", label: "Client Relationship Number" },
    { key: "address", label: "Address", type: "textarea", full: true },
    { key: "city", label: "City" },
    { key: "state", label: "State", type: "select", optionsRef: "indian_states" },
    { key: "pin_code", label: "Pin Code" },
    { key: "google_map_link", label: "Google Map Link", full: true, placeholder: "https://maps.google.com/..." },
    { key: "commissioned_on", label: "Commissioned On", type: "date" },
    { key: "contact_persons", label: "Contact Persons (Name, Email, Phone)", type: "contacts", full: true },
  ];

  const initial = {
    client_name: "",
    client_relationship_number: "",
    address: "",
    city: "",
    state: "",
    pin_code: "",
    google_map_link: "",
    commissioned_on: "",
    contact_persons: [],
  };

  return (
    <EntityPage
      title="CDARK"
      singularTitle="CDARK"
      subtitle="Client engagements with contact persons and location details."
      testidPrefix="projects"
      endpoint="/projects"
      columns={columns}
      fields={fields}
      initialForm={initial}
      referenceData={ref}
    />
  );
}
